export default {
  'SkillRow.SkillHeader.Buttons.ExpandButton': ({ open }, _, internalStateSetter) => {
    internalStateSetter({ open: !open })
  },
  'SkillRow.SkillHeader': ({ open }, _, internalStateSetter) => {
    internalStateSetter({ open: !open })
  },
  'SkillRow.SkillHeader.Buttons.DeleteParentButton': ({ skill }, outlet) => {
    outlet({ categoryId: skill.id })
  },
  'SkillRow.RowBody.ChildCategory': ({ child }, outlet) => {
    outlet({ categoryId: child.id })
  },
}